const accordion = (selector, options = {}) => {
  const {
    openedClass = 'active',
    openedByDefaultClass = 'opened-by-default',
    transitionClasses = ['transition-all', 'ease-linear', 'duration-200', 'overflow-hidden'],
    dataLayerEvent = () => {}
  } = options

  const triggers = document.querySelectorAll(selector)
  if (!triggers.length) return

  const togglePanel = (trigger, panel) => {
    const isOpen = panel.style.maxHeight

    trigger.classList.toggle(openedClass)
    panel.style.maxHeight = isOpen ? null : `${panel.scrollHeight}px`

    dataLayerEvent(trigger, isOpen ? 'close' : 'open')
  }

  triggers.forEach((trigger) => {
    const panel = trigger.nextElementSibling
    if (!panel) return

    if (panel.classList.contains(openedByDefaultClass)) {
      trigger.classList.add(openedClass)
      panel.style.maxHeight = `${panel.scrollHeight}px`
      setTimeout(() => panel.classList.add(...transitionClasses), 50)
    } else {
      panel.classList.add(...transitionClasses)
    }

    trigger.addEventListener('click', () => togglePanel(trigger, panel))
  })
}

export default accordion
